module.exports = __webpack_public_path__ + "static/tools-category-824c3ed84404cb65aad0e8b5a14ebf6f.png";